import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import "./section.scss";
import { useNavigate } from "react-router-dom";

const Section = ({
  title = "section",
  titleValues = {},
  children,
  className = "",
  style = {},
  i18n = true,
  headerAction,
  link = "",
}) => {
  const intl = useIntl();

  const navigate = useNavigate();

  const handleLink = () => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <div className={`edexlms-section ${className}`} style={style}>
      <div
        className="edexlms-section-title flex align-items-center justify-content-between"
        onClick={handleLink}
        style={{ cursor: link ? "pointer" : "default" }}
      >
        {(i18n && intl.formatMessage({ id: title }, { ...titleValues })) ||
          title}
        {headerAction || null}
      </div>
      <div className="edexlms-section-body">{children}</div>
    </div>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  titleValues: PropTypes.object,
  headerAction: PropTypes.node,
};

export default Section;
